import { APITagAttributes, ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const fetchTags = actionCreator('[tags] FETCH_TAGS');

export const notifyFetchingTagsSucceeded = actionCreator<APITagAttributes[]>(
  '[tags] NOTIFY_FETCHING_TAGS_SUCCEEDED'
);

export const notifyFetchingTagsFailed = actionCreator<{ error: string }>(
  '[tags] NOTIFY_FETCHING_TAGS_FAILED'
);

export const loadTags = actionCreator<APITagAttributes[]>('[tags] LOAD_TAGS');

export const resetTags = actionCreator('[tags] RESET_TAGS');

type AddTagsPayload = {
  tags: APITagAttributes[];
};
export const addTags = actionCreator<AddTagsPayload>('[tags] ADD_TAGS');

type ResetTagsWithDataPayload = {
  tags: APITagAttributes[];
};
export const resetTagsWithData = actionCreator<ResetTagsWithDataPayload>(
  '[tags] RESET_TAGS_WITH_DATA'
);

export const removeWorkspaceTags = actionCreator<{ workspaceId: ArdoqId }>(
  '[tags] REMOVE_WORKSPACE_TAGS'
);

export const upsertTags =
  actionCreator<APITagAttributes[]>('[tags] UPSERT_TAGS');
